<div class="d-flex align-items-center justify-content-center vh-100">
	<div class="text-center p-4 border rounded shadow-sm bg-light" style="max-width: 500px;">
    	<i class="fas fa-ban fa-3x text-danger mb-3"></i>
    	<h3 class="text-danger">Acceso no permitido</h3>
    	<p class="text-muted">No tienes permisos para ver esta pantalla o acceder a este recurso.</p>
    	<a routerLink="/" class="btn btn-primary mt-3">
        	<i class="fas fa-home me-2"></i> Volver al inicio
    	</a>
    </div>
</div>